class OkendoAccessibility extends HTMLElement {
  connectedCallback() {
    this.useVisibleProductNames();
    this.observer?.disconnect();
    this.observer = new MutationObserver(() => this.useVisibleProductNames());
    this.observer.observe(this, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-label'],
    });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  useVisibleProductNames() {
    // Okendo's label omits the visible variant. Let the link's full text name
    // it, including after hydration, filtering or a review page change.
    for (const link of this.querySelectorAll('[data-oke-widget] a.oke-product-details-name[aria-label]')) {
      if (link.textContent.trim()) link.removeAttribute('aria-label');
    }
  }
}

if (!customElements.get('okendo-accessibility')) {
  customElements.define('okendo-accessibility', OkendoAccessibility);
}
